export const ETA_PREPARATION_MARGIN = 5;

export const DEFAULT_LOCALE = "en";
export const DEFAULT_CURRENCY = "USD";
export const DELIVERECT_TERMS_AND_CONDITION =
  "https://www.deliverect.com/en/user-terms-and-conditions";
export const DELIVERECT_PRIVACY_POLICY =
  "https://www.deliverect.com/en/privacy-and-cookie-notice";
